import React from "react";
import Login from "../../components/login/login";

const LoginPage: React.FC = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;
